import styled from "styled-components";

import { colors } from "../../theme/color";

// export const CharityPaymentLinkContainer = styled.div`
//   width: 100%;
//   flex-shrink: 0;
//   // background: var(--General-White, #fff);
//   padding: 50px 16px 24px 10px;
//   box-sizing: border-box;
//   display: flex;
//   flex-direction: column;
//   gap: 20px;

//   @media screen and (max-width: 430px) {
//     width: 400px;
//   }
//   @media screen and (max-width: 327px) {
//     width: 327px;
//   }
// `;

// export const CharityPaymentLinkHeader = styled.div`
//   width: 100%;
//   // height: 32px;
//   /* border: 2px solid blue; */
//   /* padding: 20px 16px 20px 20px;
//   box-sizing: border-box; */
// `;

// export const HeaderTitle = styled.div`
//   text-align: left;

//   color: ${colors.PURPLE};

//   /* @media screen and (max-width: 1024px) {

//     text-align: left;
//   } */
//   /* @media screen and (max-width: 768px) {

//     text-align: left;
//   } */

//   @media screen and (max-width: 430px) {

//     text-align: left;
//   }

//   @media screen and (max-width: 327px) {

//     text-align: left;
//   }
// `;

// export const SubtitleText = styled.div`
//   text-align: left;

//   color: ${colors.DARK_GRAY};

//   @media screen and (max-width: 2560px) {

//   }

//   @media screen and (max-width: 768px) {

//     color: ${colors.DARK_GRAY};
//     text-align: left;
//   }

//   @media screen and (max-width: 430px) {

//     color: ${colors.DARK_GRAY};
//     text-align: left;
//   }

//   @media screen and (max-width: 375px) {

//     color: ${colors.DARK_GRAY};
//     text-align: left;
//   }
// `;

export const HorizontalLine = styled.div`
  width: 100%;
  height: 2px;
  background-color: #e8eaed;
  /* margin-top: 16px; */
`;

// export const PaymentLinkTypeContainer = styled.div`
//   width: 100%;
//   // height: 204px;
//   /* width: 576px; */
//   display: flex;
//   flex-direction: column;
//   align-items: flex-start;
//   gap: 20px;
//   /* border: 2px solid orange; */
//   @media screen and (max-width: 430px) {
//     height: 300px;
//   }
//   @media screen and (max-width: 327px) {
//     height: 300px;
//   }
// `;

// export const PaymentLinkTypeTitle = styled.div`
//   text-align: left;

//   color: ${colors.BLACK};
//   /* @media screen and (max-width: 1024px) {

//     text-align: left;
//   } */
//   /* @media screen and (max-width: 768px) {

//     text-align: left;
//   } */

//   @media screen and (max-width: 430px) {

//     text-align: left;
//   }

//   @media screen and (max-width: 327px) {

//     text-align: left;
//   }
// `;

// export const LinkTypeHolder = styled.div`
//   width: 100%;
//   display: flex;
//   /* flex-direction: column; */
//   align-items: flex-start;
//   flex-wrap: wrap;
//   /* gap: 16px; */
//   /* border: 2px solid blue; */

//   @media screen and (max-width: 430px) {
//     width: 280px;
//     height: 248px;
//     flex-direction: column;
//     gap: 10px;
//     flex-wrap: nowrap;
//   }
//   @media screen and (max-width: 327px) {
//     width: 280px;
//     height: 248px;
//     flex-direction: column;
//     gap: 10px;
//     flex-wrap: nowrap;
//   }
// `;

// export const CharityInputContainer = styled.div`
//   width: 100%;
//   display: inline-flex;
//   flex-direction: column;
//   align-items: flex-start;
//   gap: 7px;
//   //  border: 2px solid blue;
// `;

// export const PaymentLinkCharityInput = styled.input`
//   width: 80%;
//   height: 44px;
//   border: 1px solid #e8eaed;
//   border-radius: 12px;
//   text-indent: 8px;

//   &:focus {
//     outline: none;
//     border-color: #322b76;
//     background-color: #e9eaf9;
//   }
// `;

// export const CharityInputContainer1 = styled.div`
//   width: 100%;
//   display: inline-flex;
//   flex-direction: space-around;
//   align-items: center;
//   margin: 0 auto;
//   padding-top: 10px;
//   padding-bottom: 10px;
//   //   border: 2px solid blue;
// `;

// export const CreateLabel = styled.label`
//   font-weight: 400;
//   font-size: 14px;
//   margin-left: 20px;
//   margin-right: 10px;
// `;

// export const CreateInputField = styled.input`
//   width: 20%;
//   padding: 10px;
//   border: 1px solid #ccc;
//   border-radius: 4px;
//   box-sizing: border-box;
//   margin-top: 5px;
// `;

// export const OptionsContainer = styled.div`
//   width: 50%;
//   padding-top: 20px;
//   display: inline-flex;
//   flex-direction: column;
//   align-items: flex-start;
//   gap: 10px;
//   /* border: 2px solid black; */
//   @media screen and (max-width: 430px) {
//     width: 100%;
//   }
//   @media screen and (max-width: 327px) {
//     width: 100%;
//   }
// `;

// export const CheckBox = styled.input`
//   width: 16px;
//   height: 16px;
//   display: inline-flex;
//   padding-top: 2px;
//   justify-content: center;
//   align-items: center;
//   appearance: none;
//   border: 2px solid ${(props) => (props.checked ? "#00A603" : "#ccc")};
//   border-radius: 4px;
//   outline: none;
//   position: relative;

//   &:checked {
//     background-color: #ccf4cd;
//     border-color: #00a603;
//   }

//   &:checked::before {
//     content: "";
//     width: 40%;
//     height: 50%;
//     border: solid #00a603;
//     border-width: 0 2px 2px 0;
//     transform: rotate(45deg);
//     position: absolute;
//     top: 50%;
//     left: 50%;
//     transform: translate(-45%, -60%) rotate(45deg);
//   }
// `;

// export const CheckboxLabel = styled.label`
//   text-align: left;

//   color: ${colors.BLACK};

//   /* @media screen and (max-width: 1024px) {

//     text-align: left;
//   } */
//   /* @media screen and (max-width: 768px) {

//     text-align: left;
//   } */

//   /* @media screen and (max-width: 430px) {

//     text-align: left;
//   } */

//   /* @media screen and (max-width: 375px) {

//     text-align: left;
//   } */
// `;

// export const RadioContainer = styled.div`
//   display: flex;
//   /* justify-content: space-evenly; */
//   align-items: center;
//   // gap: 5px;
// `;

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  @media screen and (max-width: 768px) {
  }
`;
